import React, { Component } from "react";
import { Modal, Form, Col, Button } from "react-bootstrap";



class StudentPasswordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
    };
  }

  render() {
    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Student Password</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {this.props.stateData.currentStep == 5 ? (
            <Form.Text className="form-text text-danger">
              Update Password successfully
            </Form.Text>
          ) : (
            <Form.Text className="form-text text-danger">
              {this.props.stateData.submitError}
            </Form.Text>
          )}
          <Form>
            <Form.Row>
              <Form.Group
                as={Col}
                lg={6}
                md={12}
                sm={12}
                controlId="SelectTeacherName"
              >
                <Form.Label className="text-uppercase">
                  {" "}
                  Enter Password
                </Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={this.props.stateData.password}
                  onChange={this.props.parenthandleInputChange}
                />
                <Form.Text className="form-text text-danger">
                  {this.props.stateData.formErrors.password}
                </Form.Text>
              </Form.Group>
              <Form.Group
                as={Col}
                lg={6}
                md={12}
                sm={12}
                controlId="SelectTeacherName"
              >
                <Form.Label className="text-uppercase">
                  {" "}
                  Confirm Password
                </Form.Label>
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={this.props.stateData.confirmPassword}
                  onChange={this.props.parenthandleInputChange}
                  disabled={this.props.stateData.cButton}
                />
                <Form.Text className="form-text text-danger">
                  {this.props.stateData.formErrors.confirmPassword}
                </Form.Text>
              </Form.Group>
            </Form.Row>
          </Form>
        </Modal.Body>
        <Modal.Footer variant="white" className="px-4">
          <Button
            className="btn btn-success text-uppercase"
            onClick={this.props.handlePasswordSubmit}
          >
            {
              this.props.stateData.loadingSpinner == 1 ?
                (<div class="spinner-border text-light  loading-img-center"></div>)
                :
                ("")
            }
            Save

          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default StudentPasswordModal;
